import { render, staticRenderFns } from "./tambahluarnegeri.vue?vue&type=template&id=7e31e918&"
import script from "./tambahluarnegeri.vue?vue&type=script&lang=js&"
export * from "./tambahluarnegeri.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports